<script>
    import { slide } from "svelte-transitions"; // Импортируем slide
    import Hamburger from "svelte-hamburger";

    let open = false; //  Переменная  для  управления  меню

    function toggleMenu() {
        open = !open; // Изменяем  состояние  меню  при  нажатии
    }

    function scrollToBottom() {
        document
            .getElementById("bottomBlock")
            .scrollIntoView({ behavior: "smooth" });
        open = false; // Close the menu
    }

    function handleHomeClick(event) {
        event.preventDefault(); // Предотвращаем стандартный переход по ссылке
        if (window.location.pathname === '/') {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            open = false;
        } else {
            window.location.href = '/'; // Переход на главную страницу
        }
    }
</script>

<div class="hamburger">
    <Hamburger {open} on:click={toggleMenu} />
</div>

<div class="menu" class:open>
    <transition
        on:end={() => {
            /* Действия после завершения анимации */
        }}
        duration={500}
        out:slide
    >
        <ul class="menu-list">
            <li><button class="menuLink" on:click={handleHomeClick}>Главная</button></li>
            <li>
                <a class="menuLink" href="/workingOut">Гайды по Москве</a>
            </li>
            <li>
                <a class="menuLink" href="/workingOut">Гайды по России</a>
            </li>
            <li><a class="menuLink" href="/workingOut">Экскурсии</a></li>
            <li>
                <a class="menuLink" href="/sanatoriums">Санатории для детей</a>
            </li>
            <li>
                <button
                    class="menuLink"
                    on:click={(event) => {
                        event.preventDefault();
                        scrollToBottom();
                    }}>Контакты</button
                >
            </li>
            <li>
                <a class="menuLink" href="https://t.me/travelfamilyguide"
                    >Телеграм-канал</a
                >
            </li>
        </ul>
    </transition>
</div>

<style>
    * {
        margin: 0; /*Внешний отступ (отступ от блока)*/
        padding: 0; /*Внутренний отступ (отступ внутри блока)*/
        box-sizing: border-box; /*размеры*/
        list-style: none; /*Без стилей*/
    }

    /*  Бургер-меню  */
    .hamburger {
        position: fixed;
        top: 10px;
        right: 10px;
        background-color: #addfad;
        padding: 11px;
        border-radius: 10px;
        width: fit-content;
        margin-left: auto;
        /* position: relative; */
        z-index: 101;
    }
    .menu {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: #addfad;
        padding: 20px;
        z-index: 99;
        transform: translateY(-100%);
        transition: transform 0.5s ease-in-out; /* Плавный переход для меню */
    }

    .menu.open {
        display: block;
        transform: translateY(0);
    }
    /* Стили для списка меню */
    .menu-list {
        margin: auto;
        width: fit-content;

        display: flex; /*ПОЧИТАТЬ!!!*/
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 100%; /*Высота*/
    }

    .menuLink {
        padding-bottom: 5px; /*Внутренний отступ снизу(от слова)*/
        margin: auto; /*центрировать*/
        margin-bottom: 20px; /*Отступ от бордера до следующего блока*/
        display: block; /*Тип блока ПОЧИТАТЬ!!!*/
        width: fit-content; /*Ширина по контенту*/
        background-color: transparent;
        border: none;

        font-size: 25px;
        font-weight: 100;
        color: black;
        text-decoration: none;
        transition: cubic-bezier(0.075, 0.82, 0.165, 1) 0.5s; /*функция для анимации*/
    }
    .menuLink:hover {
        /*триггер для анимации при наведении мышки*/
        /* text-decoration: underline; */
        background-color: transparent;
        color: #4f7942;

        border-bottom: solid 2px #4f7942; /*Нижняя граница блока(линия/толщина/цвет)*/
    }
</style>
